import React, { Component } from 'react';
import hpLogo from '../../assets/images/logo/hp.svg';
import { Link } from 'react-router-dom';
import ConnectAPI from '../../services/api';
import {
  SideMenu, SideMenuItem, AppBarLeftSection, AppBarRightSection, AppBar,
  Footer, Avatar, Card, ContextualMenu, IconPerson, Button, Select, Icon, 
} from '@veneer/core';
import { authenticationService } from '../../services/context/AuthService';
import i18n from './../../i18n';
import { Trans } from 'react-i18next';
const connectApi = new ConnectAPI();
class MainLayout extends Component {
  constructor(props) {
    super(props);
    this.connectAPI = new ConnectAPI();

    if (localStorage.getItem("language") == null) localStorage.setItem("language", 'en');
    this.state = {
      currentUser: authenticationService.currentUserValue,
      language: localStorage.getItem('language')
    };
    this.headerTitle = '';
    this.itemList = authenticationService.currentUserValue.menu;
    this.listlanguage=authenticationService.currentUserValue.languageList.map((item) => {
      return{
          value: item.iso,
          label: item.native,
      };
    });

    this.removeEmpty(this.itemList);
    i18n.changeLanguage(localStorage.getItem('language'));
  }

  buildSideMenu = (itemList) => {
    itemList.sort((a, b) => a.order - b.order);
    const { location } = this.props.children.props;
    let extended = false;
    return (
      itemList &&
      itemList
        .filter((e) => {
          return (
            Object.prototype.hasOwnProperty.call(e, 'visible') && e.visible
          );
        })
        .map((item) => {
          if(Object.prototype.hasOwnProperty.call(item, 'children')){
            let extend = false;
            item.children.forEach(element => {
              if(Object.prototype.hasOwnProperty.call(element, 'children')){
                extended = element.children.some((child) => (child.url.toString().toUpperCase() == location.pathname.toString().toUpperCase() && child.url != '/'))
                if(!extend)
                  extend = element.children.some((child) => (child.url.toString().toUpperCase() == location.pathname.toString().toUpperCase() && child.url != '/'));
              }
            });
            if(extend)
              extended = true;
            else
              extended = item.children.some((item) => (item.url.toString().toUpperCase() == location.pathname.toString().toUpperCase() && item.url != '/'))
          }
          const slug = item.url;
          const lastPathName = location.pathname;
          const selected =
            slug.toString().toUpperCase() ===
            lastPathName.toString().toUpperCase();
          let url = item.url;
          if (selected) {
            this.headerTitle = item.name;
          }
          return (
            <SideMenuItem
              className="wrapped-text"
              label={<Trans i18nKey={item.name} />}
              id={'menu_' + item.name}
              key={'menu_' + item.name}
              selected={selected}
              expanded={extended}
              url={
                Object.prototype.hasOwnProperty.call(
                  item,
                  'children'
                ) || !url.startsWith("http") ? null : url
              }
              urlTarget={item.target}
              link={
                Object.prototype.hasOwnProperty.call(
                  item,
                  'children'
                ) || url.startsWith("http") ? null : (
                  <Link to={url} />
                )
              }
            >
              {Object.prototype.hasOwnProperty.call(item, 'children')
                ? this.buildSideMenu(item.children)
                : null}
            </SideMenuItem>
          );
        })
    );
  };

  removeEmpty = (obj) =>
    Object.entries(obj).forEach(([key, val]) => {
      if (val && typeof val === 'object') this.removeEmpty(val);
      else if (val == null) delete obj[key];
    });

  renderLanguageList() {
    const handleStatusChange = (name) => (event) => {
      this.setState({
        ...this.state,
        language: event.value,
      });
      let data = new FormData();
      data.append("language", event.value);
      connectApi.post(
        'api/Channels/savelanguage',
        data,
        approverSPCallback
      );
      i18n.changeLanguage(event.value);
      localStorage.setItem('language', event.value);
    };

    const approverSPCallback = (status, data) => {}
    return (
      <div
        style={{
          width: '200px',
          padding: '20px',
        }}
      >
        <Select
          name="status"
          onChange={handleStatusChange()}
          options={this.listlanguage}/*{[
            {
              value: 'en',
              label: 'English',
            },
            {
              value: 'es',
              label: 'Español',
            },
            {
              value: 'br',
              label: 'Português',
            },
          ]}*/
          clearIcon={false}
          value={[this.state.language]}
        ></Select>
      </div>
    );
  }

  render() {
    const { children } = this.props;
    const { currentUser } = this.state;
    const labelinit = (name) => {
      if(name === '' | name === null)
        return currentUser.email;
      let firstInit = name.split(' ');
      let rtn = "";
      switch(firstInit.length){
        case 1:
          rtn = firstInit[0];
          break;
        case 2,3:
          rtn = firstInit[0].split('')[0];
          rtn += firstInit[1].split('')[0];
          break;
        default:
          rtn = firstInit[0].split('')[0];
          rtn += firstInit[firstInit.length-2].split('')[0];
          break;
      }
      return rtn;
    };
    return (
      <div className="wrapper">
        <SideMenu
          expanded={false}
          logoImagePath={hpLogo}
          logoUrl="/"
          //logoImagePath={hpLogoCollapsed}
          logoTitle="HP iPSP"
        >
          {this.buildSideMenu(this.itemList)}
        </SideMenu>

        <div>
          <div className="content-page vn-background-color--background">
            <AppBar className="appbar__bottom-line" menuEnabled>
              <AppBarLeftSection>
                <h1 className="header-title" slot="left">
                  <Trans i18nKey={this.headerTitle} />
                </h1>
              </AppBarLeftSection>
              <AppBarRightSection>
                {this.renderLanguageList()}
                <ContextualMenu 
                  className='notHover'
                  placement="bottom-end"
                  options={[
                    { value: 1, label: <Card content={<>
                      <div style={{ display: 'flex', flexDirection:'row', alignItems:'center'}}>
                        <Avatar label={labelinit(currentUser.name)} />
                        <div style={{ display: 'flex', flexDirection:'column', marginLeft:'10px'}}>
                          <p>{currentUser.name}</p>
                          <p>{currentUser.email}</p>
                        </div>
                      </div>
                    </>} /> 
                    },
                    { value: 2, label: <p className='logoutClass' onClick={() => authenticationService.logout()}><Trans i18nKey={'logout'} /></p>}, 
                  ]}
                  selectedValue={2}
                >
                  <Button leadingIcon={<IconPerson />} />
                </ContextualMenu>
              </AppBarRightSection>
            </AppBar>
            <div className="row">
              <div className="col-lg-12 col"> {children} </div>
            </div>
          </div>
          <div className="footer vn-background-color--background">
            <Footer
              mainContent={{
                leftArea: (
                  <div
                    style={{
                      alignItems: 'center',
                      display: 'flex',
                      fontFamily: "'HP Simplified', Arial, sans-serif",
                      fontSize: '20px',
                    }}
                  >
                    <Icon
                      multicolor
                      name="hp"
                      size={24}
                      css={{ marginRight: '10px' }}
                    />
                    <span>iPSP</span>
                  </div>
                ),

                rightArea: <span>© Copyright. All rights reserved.</span>,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MainLayout;
